export const API_BASE_URL = '/api/v1'

// this query param is used to test domain permissions
// if you add ?domain_permissions_test=bob@bob.com then we test bob
// not the logged in user
export const DOMAIN_PERMISSIONS_TEST_EMAIL = 'domain_permissions_test_email'

// a csv of the roles to override from the carbon roles
// this is useful to test what the frontend does when we have some different carbon roles
export const DOMAIN_PERMISSIONS_TEST_ROLES = 'domain_permissions_test_roles'

export const DEFAULT_VARTREE_NAME = 'VarTree'

export const GOD_ROLE = 'Manager'
export const ADMIN_ROLE = 'Realm'
export const PLATINUM_ROLE = 'Platinum'
export const RUBY_ROLE = 'Ruby'
export const AGENT_ROLE = 'Agent'

export const HELP_VIDEO_URL_ADMIN_USERS = 'https://youtu.be/CS_eqHowoHY'
export const HELP_VIDEO_URL_ADMIN_CONTEXT = 'https://youtu.be/_1J8FKGaPJc'
export const HELP_VIDEO_URL_ADMIN_PERSONA = 'https://youtu.be/x4BGTv4_Iqs'

// Agent query timeout — must match orchestrator's AbortSignal.timeout in sessions.ts
export const AGENT_QUERY_TIMEOUT_MS = 20 * 60 * 1000 // 20 minutes